import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import Slider from 'react-slick';
import Img from 'gatsby-image';
import { Helmet } from 'react-helmet';
import Bounce from 'react-reveal/Bounce';
import Zoom from 'react-reveal/Zoom';
import { AiOutlineArrowRight } from 'react-icons/ai';
import { FaExternalLinkSquareAlt } from 'react-icons/fa';
import circle from '../images/circle.png';

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  arrows: true,
  slidesToShow: 3,
  slidesToScroll: 3,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

function FeaturedProjects() {
  const {
    allContentfulProject: { nodes: projects },
  } = useStaticQuery(graphql`
    query featuredProjects {
      allContentfulProject(sort: { fields: serial }, limit: 6) {
        nodes {
          id
          title
          category
          date
          slug
          imageOne {
            fluid {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
    }
  `);

  return (
    <div className='bg-white ' style={{ backgroundColor: '$primary-color', paddingBottom: '1.5rem' }}>
      <div className='container py-5 featuredProject'>
        <img className='circle' src={circle} alt='' />
        <div className='row mt-5 text-center'>
          <div className='col-md-8 col-lg-6 mx-auto project-header'>
            <Bounce>
              <h4>OUR PROJECTS</h4>
            </Bounce>
            <p>
              All functions including supply chain, value chain, project scheduling, manufacturing, services and spares,
              technology, R&D, etc. are integrated to give a complete solutions package.
            </p>
          </div>
        </div>
        <div className='row my-4' style={{ maxWidth: '100%' }}>
          <Slider {...settings}>
            {projects.map((project) => {
              const { id, slug, imageOne, title } = project;
              return (
                <div key={id} className='f-project-card' style={{ cursor: 'grab' }}>
                  <Img className='image' fluid={imageOne.fluid} style={{ height: '280px' }} />
                  <div className='f-project-details'>
                    <h2>{title}</h2>
                    <Link className='link' to={`/projects/${slug}`}>
                      <FaExternalLinkSquareAlt className='icon' />
                    </Link>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
        <Bounce bottom>
          <div className='row mt-3 mb-5 d-flex flex-column justify-content-center align-items-center'>
            <Link to='/projects' className='more-container mt-3'>
              See All Projects
              <AiOutlineArrowRight className='icon' />
            </Link>
          </div>
        </Bounce>
      </div>
    </div>
  );
}

export default FeaturedProjects;
